import axios from 'axios';
import apisUrls from '../urls';

const changeClientStatusApi = (values) => {
  return axios.post(apisUrls?.changeClientStatus, values, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export default changeClientStatusApi;
